import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { IViewsAndUploadAction, uploadAction, hideAction, IViewsAndUploadStoreState } from '@/redux/imgs/viewsAndUpload';
const Toast = require('react-toast-mobile');

interface IProps {
    hideAction(): void;
    uploadAction(e: any): void;
    src: string;
    visible: boolean;
};

class ViewsAndUpload extends React.Component<IProps, any> {
    constructor(props: any) {
        super(props);
    }
    public render() {
        return (
            <div className={`views-img reupload ${this.props.visible ? 'active' : ''}`}>
                <img src={require('../../../../assets/images/icon-close.png')} className="views-close" onClick={() => this.props.hideAction()}/>
                <div className="views-img-content">
                    <img src={this.props.src} onLoad={() => this.imgLoad()}/>
                </div>
                <a href="javascript:;" className="reuploadfile">重新上传<input type="file" name="file" accept="image/*" onChange={(e: any) => this.uploadAction(e)}/> </a>
            </div>
        )
    }
    private uploadAction(e: any) {
        this.props.uploadAction(e);
        e.target.value = '';
    }
    private imgLoad() {
        Toast.T.loaded();
    }
}

const mapStateToProps = ( state: any ): IViewsAndUploadStoreState => {
    return {
        ...state.viewsAndUploadReducers
    };
};

const mapDispatchToProps = ( dispatch: Dispatch<IViewsAndUploadAction> ) => {
    return bindActionCreators({ hideAction, uploadAction }, dispatch);
};

export default connect( mapStateToProps, mapDispatchToProps )(ViewsAndUpload);